import './assets/main.css'
import 'vant/lib/index.css'; // 引入 Vant 样式
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'; //引入VueWechatTitle
import { createPinia } from "pinia";
import 'amfe-flexible'
import Vant from 'vant';
import Vconsole from 'vconsole'

if (import.meta.env.VITE_NODE_ENV !== "production") {
    // 测试和开发打开，生产不能打开
    new Vconsole();
}
const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(Vant)
app.use(router)
app.use(VueWechatTitle)
app.mount('#app')
